
import Header from "../Header/Header";
import React, {useEffect, useState} from "react";
import './Home.css';
import SelectableBlockHome from "../SelectableBlockHome/SelectableBlockHome";
import {useSelection} from "../../SelectionContext";
import {useNavigation} from "../../NavigationContext";
import Translate from "../../Translate";

export default function Home({ setCurrentIndex }) {


    const options = [
        { title: "VR Tallinn", titleAdditional: "1939/44", address: "Vabaduse Väljak 9 (tunnel), Tallinn", city: "Tallinn", className: "Damion" },
        { title: "VR Toila", titleAdditional: "1938", address: "Lossiplatsi tn 3, Toila", city: "Toila", className: "Italianno" },
        { title: "VR Tartu", titleAdditional: "1913", address: "Kaarsild, Tartu", city: "Tartu", className: "BelweMediumBT" },
    ];

    const { selection, updateSelection } = useSelection();
    const { setNextEnabled } = useNavigation();

    const handleSelect = (city) => {
        updateSelection("location", city);
        setCurrentIndex((prev) => prev + 1);  // Переход на следующий слайд
    };

    useEffect(() => {
        setNextEnabled(!!selection.location);
    }, [selection.location, setNextEnabled]);

    return (
        <div className="home-main-container">
            <div className="home-container">
                <div className="blocks-container">
                    {options.map((option) => (
                        <SelectableBlockHome
                            key={option.title}
                            title={option.title}
                            titleAdditional={option.titleAdditional}
                            customClassH1={option.className + " home-page-class-h1"}
                            customClassH2={option.className + " home-page-class-h2"}
                            address={option.address}
                            isSelected={selection.location === option.title} // Проверяем глобальный стейт
                            onSelect={() => handleSelect(option.city)} // Записываем выбор
                        />
                    ))}
                    </div>
                </div>
            {selection.location && (
                <div className="selected-info">
                    <p><Translate id="ChooseTown"/><strong>{selection.location}</strong></p>
                </div>
            )}
        </div>
    )
}